// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"_3LEiKj","container":"_2A-nTY","content":"_3zUMyx","image":"tUbbvS"};